module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/credit-card-255a6415a4e9886413a8ca0cf78fdf98.svg";